/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FAnonymousType112 } from './FAnonymousType112';
import {
    FAnonymousType112FromJSON,
    FAnonymousType112FromJSONTyped,
    FAnonymousType112ToJSON,
    FAnonymousType112ToJSONTyped,
} from './FAnonymousType112';
import type { FAnonymousType145 } from './FAnonymousType145';
import {
    FAnonymousType145FromJSON,
    FAnonymousType145FromJSONTyped,
    FAnonymousType145ToJSON,
    FAnonymousType145ToJSONTyped,
} from './FAnonymousType145';
import type { FAnonymousType162 } from './FAnonymousType162';
import {
    FAnonymousType162FromJSON,
    FAnonymousType162FromJSONTyped,
    FAnonymousType162ToJSON,
    FAnonymousType162ToJSONTyped,
} from './FAnonymousType162';

/**
 * 
 * @export
 * @interface FAnonymousType176
 */
export interface FAnonymousType176 {
    /**
     * 
     * @type {number}
     * @memberof FAnonymousType176
     */
    id?: number;
    /**
     * 
     * @type {FAnonymousType112}
     * @memberof FAnonymousType176
     */
    definition?: FAnonymousType112;
    /**
     * 
     * @type {string}
     * @memberof FAnonymousType176
     */
    status?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FAnonymousType176
     */
    created?: Date;
    /**
     * 
     * @type {FAnonymousType145}
     * @memberof FAnonymousType176
     */
    analysis?: FAnonymousType145;
    /**
     * 
     * @type {Array<FAnonymousType162>}
     * @memberof FAnonymousType176
     */
    measurements?: Array<FAnonymousType162> | null;
}

/**
 * Check if a given object implements the FAnonymousType176 interface.
 */
export function instanceOfFAnonymousType176(value: object): value is FAnonymousType176 {
    return true;
}

export function FAnonymousType176FromJSON(json: any): FAnonymousType176 {
    return FAnonymousType176FromJSONTyped(json, false);
}

export function FAnonymousType176FromJSONTyped(json: any, ignoreDiscriminator: boolean): FAnonymousType176 {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'definition': json['definition'] == null ? undefined : FAnonymousType112FromJSON(json['definition']),
        'status': json['status'] == null ? undefined : json['status'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'analysis': json['analysis'] == null ? undefined : FAnonymousType145FromJSON(json['analysis']),
        'measurements': json['measurements'] == null ? undefined : ((json['measurements'] as Array<any>).map(FAnonymousType162FromJSON)),
    };
}

export function FAnonymousType176ToJSON(json: any): FAnonymousType176 {
    return FAnonymousType176ToJSONTyped(json, false);
}

export function FAnonymousType176ToJSONTyped(value?: FAnonymousType176 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'definition': FAnonymousType112ToJSON(value['definition']),
        'status': value['status'],
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
        'analysis': FAnonymousType145ToJSON(value['analysis']),
        'measurements': value['measurements'] == null ? undefined : ((value['measurements'] as Array<any>).map(FAnonymousType162ToJSON)),
    };
}

